import React, { useState } from "react";

export default function TableComponent({ tableColumns, tableData }) {
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page state
  const [searchQuery, setSearchQuery] = useState(""); // Search query state

  // Filter data based on search query
  const filteredData = tableData.filter((row) =>
    tableColumns.some((col) =>
      String(row[col.accessor])
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    )
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page when search query changes
  };

  return (
    <div
      style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
    >
      <div style={{ width: "80%" }}>
        {/* Search Input */}
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            className="search-input"
            onChange={handleSearchChange}
            style={{
              padding: "8px",
              width: "100%",
              fontSize: "13px",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          />
        </div>

        {/* Table */}
        <table className="table table-bordered table-striped table-hover text-sm">
          {/* Table Head */}
          <thead>
            <tr style={{ background: "#f4f4f4", height: "35px" }}>
              {tableColumns.map((col, index) => (
                <th
                  key={index}
                  style={{ padding: "8px", border: "1px solid #ddd" }}
                >
                  {col.Header}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((row, rowIndex) => (
                <tr key={rowIndex} style={{ height: "35px" }}>
                  {tableColumns.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      style={{ padding: "8px", border: "1px solid #ddd" }}
                    >
                      {col.accessor === "status" ? (
                        <span
                          style={{
                            backgroundColor:
                              row[col.accessor] === "APPROVED"
                                ? "#d4edda"
                                : row[col.accessor] === "REJECTED"
                                ? "#f8d7da"
                                : "transparent",
                            color:
                              row[col.accessor] === "APPROVED"
                                ? "#155724"
                                : row[col.accessor] === "REJECTED"
                                ? "#721c24"
                                : "inherit",
                            padding:
                              row[col.accessor] === "APPROVED" ||
                              row[col.accessor] === "REJECTED"
                                ? "4px 8px"
                                : "inherit",
                            borderRadius:
                              row[col.accessor] === "APPROVED" ||
                              row[col.accessor] === "REJECTED"
                                ? "4px"
                                : "inherit",
                            fontWeight:
                              row[col.accessor] === "APPROVED" ||
                              row[col.accessor] === "REJECTED"
                                ? "bold"
                                : "inherit",
                          }}
                        >
                          {row[col.accessor]}
                        </span>
                      ) : (
                        row[col.accessor]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={tableColumns.length}
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    border: "1px solid #ddd",
                  }}
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Items per page dropdown */}
          <div>
            <span style={{ color: "blue" }}>Items per page: </span>
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              style={{ padding: "5px", fontSize: "13px", color: "blue" }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>

          {/* Pagination buttons */}
          <div>
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                padding: "5px 10px",
                marginRight: "5px",
                fontSize: "13px",
                cursor: "pointer",
                color: "blue",
              }}
            >
              Previous
            </button>
            <span style={{ color: "blue" }}>
              Page {currentPage} of{" "}
              {Math.ceil(filteredData.length / itemsPerPage)}
            </span>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={
                currentPage === Math.ceil(filteredData.length / itemsPerPage)
              }
              style={{
                padding: "5px 10px",
                marginLeft: "5px",
                fontSize: "13px",
                cursor: "pointer",
                color: "blue",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
